export const PANEL_THEMES = ['PRAIA', 'ESCURO', 'CLARO'];
export const DEFAULT_PANEL_THEME = 'PRAIA';
export const PANEL_THEME_LABELS = {
    PRAIA: 'Praia',
    ESCURO: 'Escuro',
    CLARO: 'Claro'
};
/** O que veio do servidor, ou o padrao quando nao e um tema conhecido. */
export function safePanelTheme(value) {
    return PANEL_THEMES.includes(value) ? value : DEFAULT_PANEL_THEME;
}
//# sourceMappingURL=panel-theme.js.map